import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/ui-bits";

const fmt = (n) => +Number(n || 0).toFixed(2);

export default function StockTakeItemsList({ items, onRemove }) {
  const sorted = [...items].sort((a, b) => (b.added_at || "").localeCompare(a.added_at || ""));
  return (
    <Panel title={`Counted in draft (${items.length})`}>
      {items.length === 0 ? (
        <div className="text-sm text-stone-500 py-10 text-center" data-testid="stocktake-items-empty">
          Nothing counted yet. Scan the first item to start.
        </div>
      ) : (
        <div className="divide-y divide-border" data-testid="stocktake-items-list">
          {sorted.map((it) => (
            <div key={it.id} className="py-3 flex items-center gap-3" data-testid={`stocktake-item-${it.id}`}>
              <div className="min-w-0 flex-1 grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-1 text-sm">
                <div className="col-span-2 md:col-span-1">
                  <div className="font-semibold truncate">{it.material_name}</div>
                  <div className="text-xs text-stone-500 truncate">{it.supplier_name}</div>
                </div>
                <div className="font-mono text-xs self-center truncate">{it.supplier_batch}</div>
                <div className="tnum self-center">
                  <span className="font-semibold">{fmt(it.quantity)} {it.unit}</span>
                  <div className="text-[11px] text-stone-500">{fmt(it.pack_count)} × {fmt(it.pack_size)} {it.pack_unit}</div>
                </div>
                <div className="tnum text-xs self-center">Exp {it.expiry_date?.slice(0, 10)}</div>
                <div className="text-xs text-stone-500 self-center">{it.added_by_name} · {it.added_at?.slice(11, 16)}</div>
              </div>
              <Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 text-rose-600 hover:bg-rose-50"
                onClick={() => onRemove(it)} data-testid={`stocktake-remove-${it.id}`}>
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
